import React from 'react'
import { Picker, Flex } from 'antd-mobile'
import storeOriginalList from './store'

class Store extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      storeList: [],
      provinceList: [],
      cityMap: [],
      cityList: [],
      filterStoreList: [],
    }
  }
  componentDidMount() {
    // console.log(storeOriginalList)
    const storeList = []
    const cityMap = {}
    const provinceList = ['全部']

    storeOriginalList.map(o => {
      const province = o[0]
      const city = o[1]
      if (provinceList.indexOf(province) < 0) {
        provinceList.push(province)
      }
      if (!!!cityMap[province]) {
        cityMap[province] = [city]
      } else if (cityMap[province].indexOf(city) < 0){
        cityMap[province].push(city)
      }
      storeList.push({
        province,
        city,
        id: o[2],
        name: o[3],
        address: o[4],
        phone: o[5],
      })
    })
    this.setState({
      storeList,
      provinceList,
      cityMap,
    })
    // console.log(storeList, cityMap, provinceList)
  }
  handleChangePrivince(val) {
    this.setState({
      selectedProvince: val,
      cityList: val[0] === '全部' ? ['全部'] : this.state.cityMap[val],
      // filterStoreList: [],
      selectedCity: val[0] === '全部' ? ['全部'] : [this.state.cityMap[val][0]]
    }, () => {
      this.handleChangeStore()
    })
  }
  handleChangeStore() {
    this.setState({
      filterStoreList: this.state.selectedProvince[0] === '全部' ? this.state.storeList :
      this.state.storeList.filter(o => {
        // console.log(this.state, o)
        return o.province == this.state.selectedProvince[0] && o.city == this.state.selectedCity[0]
      })
    })
  }
  handleChangeCity(val) {
    this.setState({
      selectedCity: val,
    }, () => {
      this.handleChangeStore()
    })
  }
  render() {
    const cellStyle={width: '50%', textAlign: 'center', padding: '.1rem', fontSize: '.16rem', fontWeight: '700'}
    const cellContentStyle={...cellStyle, fontSize: '.12rem', textAlign: 'left', fontWeight: '400'}
    return (
      <div style={{
              backgroundImage: `url(${ require('img/bg.png') })`,
              backgroundSize: '100% auto',
              backgroundRepeat: 'no-repeat',
              height: '100%',
              width: '100%',
              backgroundColor: '#fff',
              overflow: 'auto',
           }}>
        <div  style={{
                position: 'absolute',
                top: '2.09rem',
                fontSize:'.18rem',
                left: '.5rem',
                width: 'calc(100% - 1rem)'
              }} >
          <Picker data={ this.state.provinceList.map(o => ({ label: o, value: o })) }
                 onOk={ this.handleChangePrivince.bind(this) } cols={ 1 } >
            <div>{ this.state.selectedProvince || '省份' }</div>
          </Picker>
        </div>
        <div  style={{
                position: 'absolute',
                top: '2.62rem',
                fontSize:'.18rem',
                left: '.5rem',
                width: 'calc(100% - 1rem)'
              }} >
          <Picker data={ this.state.cityList.map(o => ({ label: o, value: o })) }
                  disabled={ this.state.cityList.length == 0 }
                  onOk={ this.handleChangeCity.bind(this) } cols={ 1 } >
            <div>{ this.state.selectedCity || '城市' }</div>
          </Picker>
        </div>
        <div style={{
             position: 'relative', top: '3.2rem',
             margin: '0 .16rem', paddingBottom: '.5rem', overflow: 'auto',
             width: 'calc(100% - .32rem)', fontSize: '.18rem', textAlign:'center',
             position: 'relative'
          }}>
          <div style={{
              border: '3px solid #44CFA7',
              backgroundColor: '#d9f4e9',
              borderRadius: '.2rem',
              // maxHeight: '100%',

            }}>
            <Flex justify='between' align='center' style={{ borderBottom: '3px solid #44CFA7' }}>
              <div style={ cellStyle }>门店名称</div>
              <div style={{ ...cellStyle, borderLeft: '3px solid #44CFA7' }}>地址</div>

            </Flex>
            {
              this.state.filterStoreList.length === 0 && (
                <div style={{...cellStyle, width: '100%'}}>请先选择省市</div>
              )
            }
            <div style={{ width: '100%',}}>
              {
                this.state.filterStoreList.map((o, i) => {
                  return (
                    <Flex justify='between' align='center'
                          style={{ borderBottom: (i+1 === this.state.filterStoreList.length) ? 'none' :'3px solid #44CFA7' }}>
                      <div style={ cellContentStyle }>{o.name}</div>
                      <div style={{
                              ...cellContentStyle,
                               borderLeft: '3px solid #44CFA7',

                            }}>
                        {o.address}
                      </div>

                    </Flex>
                  )
                })
              }
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Store
// <div style={ cellStyle }>联系电话</div>
//
// <div style={ cellContentStyle }>
  // <a href={ `tel:${ o.phone }` } style={{ color: '#333' }}>{o.phone.replace(/-/g, '')}</a></div>
